const Backbone = require('backbone');
const Utils = require('src/app/views/store/common/utility');
require('src/app/templates/store/global/pages/account/projects/common/status/_status_loading.dust');
let _singleton = null;

class ProjectStatusHelper {
	static events = {
		slow: 'project:status:helper:slow',
		complete: 'project:status:helper:complete'
	};

	static properties = ['query', 'duration', 'easing', 'toggleClass', 'threshold', 'message'];

	static defaultMessage = 'Processing. Please wait...';
	static defaultErrorMessage = 'Sorry, but something went wrong. Please refresh the page and try again.';

	static getInstance(options = {}) {
		if (!_singleton) {
			_singleton = new ProjectStatusHelper(options);
		}
		return _singleton;
	}

	constructor(options = {}) {
		Object.assign(this, Utils.accept(options, ['rootEl', 'messageResolver'], this._getDefaults()), Backbone.Events);
	}

	_isFeatureEnabled() {
		return window.dataLayer.model.isProjectsErrorHandling;
	}

	_getDefaults() {
		return {
			rootEl: $('body'),
			query: '.js-loading',
			duration: 250,
			easing: 'linear',
			toggleClass: 'hide',
			threshold: 1000
		};
	}

	_clearTimeout() {
		if (Utils.defined(this._timeoutId)) {
			clearTimeout(this._timeoutId);
			this._timeoutId = null;
		}
		return this;
	}

	_defaultMessageResolver(type, messages) {
		if (Utils.defined(messages)) {
			return Utils.defined(messages[type]) ? messages[type] : ProjectStatusHelper.defaultMessage;
		}
		return ProjectStatusHelper.defaultMessage;
	}

	_resolveMessage(type, messages) {
		return Utils.defined(this.messageResolver) ? this.messageResolver(type, messages) : this._defaultMessageResolver(type, messages);
	}

	_resolveParams(type, messages, params = {}) {
		const data = Utils.accept(params, ProjectStatusHelper.properties, this._getDefaults());
		return { ...data, type, message: this._resolveMessage(type, messages), $target: this.rootEl.find(data.query) };
	}

	_fireEvent(show, params) {
		if (Utils.defined(this._timeoutId) && show) {
			this.trigger(ProjectStatusHelper.events.slow, params, this);
		} else if (this._isSlow) {
			this._isSlow = false;
			this.trigger(ProjectStatusHelper.events.complete, params, this);
		}
		return this;
	}

	_animate(params, show, isSlow = false) {
		const { $target, duration, easing } = params,
			opacity = show ? 1 : 0;
		this._visible(params, show)._message(params, show);
		$target.animate({ opacity }, duration, easing, this._onComplete.bind(this, show, params));
		this._isSlow = isSlow;
		return this._fireEvent(show, params);
	}

	_handle(type, params, show) {
		if (!Utils.defined(this._timeoutId) && show) {
			this._timeoutId = setTimeout(this._animate.bind(this, params, show), params.threshold, true);
		} else {
			this._animate(params, show, this._isSlow && !Utils.defined(this._timeoutId));
		}
		return this;
	}

	_onComplete(show, params) {
		const { $target, toggleClass } = params;
		show ? $target.removeClass(toggleClass) : $target.addClass(toggleClass);
	}

	_visible(params, show) {
		const { $target, toggleClass } = params;
		if (show) {
			$target.removeClass(toggleClass).css({ opacity: 0 });
		}
		return this;
	}

	_message(params, show) {
		const { $target, message } = params;
		if (show) {
			$target.text(message || '');
		}
		return this;
	}

	show(type = '', messages = {}, params = {}) {
		if (this._isFeatureEnabled()) {
			if (!Utils.defined(type)) {
				type = '';
			}
			if (typeof type === 'string') {
				this._clearTimeout()._handle(type, this._resolveParams(type, messages, params), true);
			}
		}
		return this;
	}

	hide(type = '', params = {}) {
		if (this._isFeatureEnabled()) {
			if (!Utils.defined(type)) {
				type = '';
			}
			this._clearTimeout();
			if (typeof type === 'string') {
				this._handle(type, this._resolveParams(type, null, params), false);
			}
		}
		return this;
	}

	handleError(type = '', params = {}) {
		const { error, autoHide, ...filtered } = params;
		if (this._isFeatureEnabled()) {
			if (error && typeof error === 'object' && error.status === 0 && typeof error.message === 'string') {
				window.BCOM.notifications.render(error.message, 'danger', Boolean(autoHide));
			} else if (Utils.defined(error)) {
				window.BCOM.notifications.render(ProjectStatusHelper.defaultErrorMessage, 'danger', Boolean(autoHide));
			}
			this.hide(type, filtered);
		}
		window.clientErrorHandler(error);
		return this;
	}
}

module.exports = { StatusGet: ProjectStatusHelper.getInstance, StatusEvents: ProjectStatusHelper.events };
